import axios from "axios";
import { getAuth } from "../../app/modules/auth";

export function getAPIClient() {
  const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
  });

  // O SEGREDO ESTÁ AQUI: O Interceptor roda antes de CADA requisição sair
  api.interceptors.request.use(
    (config) => {
      // 1. Pega o token fresquinho direto do helper na exata hora do disparo
      const authData = getAuth();
      const token = authData?.api_token;

      // 2. Se o token existir, injeta no cabeçalho
      if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  return api;
}

export const api = getAPIClient();